import { Box, Dialog, DialogContent } from "@mui/material"
import { BoxFC, BoxFR } from "components/BoxCustom"
import PaperComponent from "components/PaperComponent"
import { DialogFooter, DialogHeader } from "components/dialog/DialogHeader"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react"
import { clearFilterData, initPCPeriodFilterData } from "./initData"
import SearchButton from "components/buttons/SearchButton"
import ClearButton from "components/buttons/ClearButton"
import DateTimeSelect from "components/DateTimeSelect"
import { shoreApiNm } from "constants/shoreConstant"
import { addIdForDataGrid } from "utils"
import { pcPeriodColumnsLIT, shorePeriodColumns } from "./columns"
import DataGridCellExpand from "components/DataGridCellExpand/DataGridCellExpand"
import ComboBox from "components/ComboBox"
import { alertError } from "components/Alert"
import ShorePeriodDialogLIT from "./ShorePeriodDialogLIT"
import AddButton from "components/buttons/AddButton"

let selectedPCPrdId = null
let prevBal  = 0
let lastFilter = null
const PCPrdListDialogLIT = ({  dialogOpen, setDialogOpen}) => {
  const { ax, msData } = useContext(GlobalStateContext)

  const initShoreBalDataMemo = useMemo(()=>{
    return {
      ...initPCPeriodFilterData,
      PCJnlId: msData.pcJournalCombo.find(item => item.IsDf)?.id || null
    }
  }, [msData.pcJournalCombo])

  const [dataTable, setDataTable] = useState([])
  const [filterData, setFilterData] = useState({ ...initShoreBalDataMemo })
  const [dialogShorePeriodOpen, setDialogShorePeriodOpen] = useState(false)

  const getData = useCallback((filter) => {
    if(!filter.PCJnlId) {
      alertError("กรุณาเลือกสมุดบัญชี")
      return
    }
    ax.post(shoreApiNm.getShorePeriodTable, filter).then(value => {
      if (value.data) {
        lastFilter = filter
        setDataTable(addIdForDataGrid(value.data, "PCPrdId"))
      }
    })
  }, [ax])

  const showDetail = useCallback((params) => {
    selectedPCPrdId = params.id
    prevBal = params.row.Bal
    setDialogShorePeriodOpen(true)
  }, [])

  const handleCellClick = useCallback((params) => {
    if (params.field === "ShowDetail") {
      showDetail(params)
    }
  }, [showDetail])

  const handleRowDoubleClick = useCallback((params) => {
    showDetail(params)
  }, [showDetail])

  const onShorePeriodDialogFinish = useCallback((data) => {
    getData(lastFilter)
  }, [getData])

  const handleAddPCPrd = useCallback(() => {
    selectedPCPrdId = null
    setDialogShorePeriodOpen(true)
  }, [])

  useEffect(() => {
    if (dialogOpen) {
      console.log("initShoreBalDataMemo::", initShoreBalDataMemo)
      getData({ ...initShoreBalDataMemo,})
    } else {
      setDataTable([])
    }
  }, [dialogOpen, ax, getData, initShoreBalDataMemo]
)

console.log("in PCPRDListDialog FilterData::", filterData)
  return (
    <Dialog
      open={dialogOpen}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth='lg'
    >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title="รายการปิดยอดค่าใช้จ่าย"
        onDeleteClick={null}
      />
      <DialogContent>
        <BoxFC pt={2} >
          <BoxFR>
            <AddButton onClick={handleAddPCPrd}>เพิ่มการปิดยอด</AddButton>
            <Box flex={1} />
            <ComboBox sx={{ width: 150 }} options={msData.pcJournalCombo} label="สมุดบัญชี" required={true}
            selectedId={filterData.PCJnlId} setSelectedId={(id) => setFilterData(o => ({ ...o, PCJnlId: id }))} />
            <DateTimeSelect
              sx={{ width: 180 }}
              label="วันที่ปิดยอด"
              start={filterData.PCPrdTmSt}
              end={filterData.PCPrdTmEn}
              setSelectDate={(st, en) => { setFilterData(o => ({ ...o, PCPrdTmSt: st, PCPrdTmEn: en })) }}
              getData={() => { getData(filterData) }}
            />
            <SearchButton onClick={() => getData(filterData)} />
            <ClearButton onClick={() => setFilterData({ ...clearFilterData })} />
          </BoxFR>
          <Box height={600} >
            <DataGridCellExpand
              hideFooter
              rows={dataTable}
              columns={pcPeriodColumnsLIT}
              onCellClick={handleCellClick}
              onRowDoubleClick={handleRowDoubleClick}
            />
          </Box>

          <ShorePeriodDialogLIT
            pcPrdId={selectedPCPrdId}
            prevBal={prevBal}
            dialogOpen={dialogShorePeriodOpen}
            setDialogOpen={setDialogShorePeriodOpen} 
            onFinish={onShorePeriodDialogFinish}
            columns={shorePeriodColumns}/>
        </BoxFC>
      </DialogContent>
      <DialogFooter okText={""}
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={null} />
    </Dialog>
  )
}

export default React.memo(PCPrdListDialogLIT)